'use client';
import React from 'react';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Box, Stack } from '@mui/material';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';

import CommonContainer from '@components/CommonContainer';
import CommonDynamicButton from '../CommonDynamicButton';
import WestminsterTowerWatchFilm from '../WestminsterTowerWatchFilm';
import cn from './style.module.scss';

export default function WestminsterTowerWelcome(
  props: MarketingPageComponentProps
) {
  return (
    <Stack component="section" className={cn.westminsterTowerWelcome}>
      <Box className={cn.westminsterWelcomeInner}>
        <Box className={cn.westminsterWelcomeBlock}>
          <Box className={cn.westminsterWelcomeBlock__content}>
            <CommonContainer
              paddingInline={{ xs: '32px', sm: '32px', md: '24px' }}
              maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
              flexGrow={1}
            >
              <Box className={cn.westminsterWelcomeText}>
                <Box className={cn.westminsterWelcomeText__element}>
                  <ParallaxText
                    variant="p"
                    animationType="slideInBottom"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(
                      props.locale.section.westminsterTowerWelcomeContent
                    )}
                  </ParallaxText>
                </Box>
              </Box>
            </CommonContainer>
          </Box>
          <Box
            className={cn.westminsterWelcomeBlock__watch}
            sx={{
              backgroundImage: `url(${props.images.westminster_tower_dark_background?.src})`,
            }}
          >
            <WestminsterTowerWatchFilm {...props} />
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
